<template>
  <div>
    <el-dropdown trigger="click">
      <span class="el-dropdown-link">
        <dl class="user-phone">
            <dt>
                <el-avatar class="avatar" :size="30" :src="avatar || '/user.png'" v-popover:popover></el-avatar>
            </dt>
            <dd>
                <span>{{isLogin ? user.name : (user.username ? user.username : '注册用户')}}</span>
            </dd>
        </dl>
        <i class="el-icon-caret-bottom el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown" class="boxs" v-if="isLogin">
        <!-- <el-dropdown-item v-if='isOrgManager' @click.native="()=>{$router.replace('/user/organizational')}">组织管理</el-dropdown-item> -->
        <!-- <el-dropdown-item v-if='isOrgManager' @click.native="()=>{$router.replace('/user/storage')}">存储空间管理</el-dropdown-item> -->
        <el-dropdown-item @click.native="()=>{$router.replace('/manager/user/resetpassword')}">修改密码</el-dropdown-item>
        <el-dropdown-item @click.native="()=>{$router.replace('/manager/user/mydetails')}">详细资料</el-dropdown-item>
        <el-dropdown-item v-if='checkShow()' @click.native="()=>{$router.replace('/user/preference')}">偏好设置</el-dropdown-item>
        <el-dropdown-item @click.native="out">退出登录</el-dropdown-item>
      </el-dropdown-menu>
      <el-dropdown-menu slot="dropdown" class="boxs" v-else>
        <el-dropdown-item @click.native="$router.push(`/login?redirect=${$route.path}`)">去登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { Store } from '@lk/cache'
import Cookies from 'js-cookie'
  export default {
    data() {
      return {};
    },
    computed: {
      isLogin(){
        if(  this.$store.state.login.id && Store.get('access_token')){
          return true
        }else{
          return false
        }
      },
      user(){
        return this.$store.state.login
      },
      avatar(){
        return this.$store.state.login.avatar
      },
      isOrgManager(){
        let roles = this.$store.state.login.roles;
        let arr = roles.filter( m => m.authority == 'TENANT_MANAGER')
        return arr.length == 0 ? false:true
      },
     
    },
    watch: {},
    methods: {
      // 检查是否显示，租户管理员角色和工具系统管理员角色隐藏掉部分下拉菜单
      checkShow(){
          // 租户管理员角色
          const tenantManager = this.user.roles.some(item=>item.authority=='TENANT_MANAGER')
          // 工具系统管理员
          const toolSysManager = this.user.roles.some(item=>item.authority=='DOC_TOOL_MANAGER')
          if(tenantManager || toolSysManager){
            return false
          }else{
            return true
          }

      },
      out() {
        Cookies.remove('access_token');
        Cookies.remove('user_info');
        this.$store.dispatch("login/logout").then(state =>{

          window.location.reload()
          window.localStorage.clear()
        })
      },
    },

    created() {
      this.$store.dispatch("login/loadLoginUserInfo");
      this.$store.dispatch("login/getUserUsedDist");
    },
  };
</script>
<style lang='less' scoped>
  @import "../../styles/index.less";

  // .avatar {
  //   margin-right: 5px;
  //   cursor: pointer;
  // }

  .user-box {
    padding: 0 10px;
  }

  .user-name {
    font-size: @h6;
  }

  .el-avatar {
    background: #fff;
    vertical-align: middle;
    margin-top: -6px;
  }

  .el-dropdown {
    .el-dropdown-link {
      display: flex;
      align-items: center;
      .user-phone {
          display: flex;
          align-items: center;
          margin: 0;
          padding: 0;
          cursor: pointer;
          dt {
            margin: 0;
            padding: 0;
          }
          dd {
            margin: 0;
            padding: 0;
            span {
              display: inline-block;
              margin-bottom: 3px;
            }
          }
        }
    }
    // .el-dropdown-menu.boxs{
    //    .popper__arrow {
    //       display: none;
    //     }
    // }
  }
 
  
</style>